module.exports = "<div class=\"confimation-toolbox animated fadeInRight\">\n    <div>\n        Are you sure you want to delete ?\n    </div>\n    <div>\n        <button type=\"button\" class=\"btn btn-primary btn-sm btn-outline pull-right\" style=\"margin: 5px 0px 0px 5px;\" (click)=\"onOk();\">Ok</button>\n        <button type=\"button\" class=\"btn btn-primary btn-sm btn-outline pull-right\" style=\"margin: 5px 0px 0px 0px;\" (click)=\"onCancel();\">Cancel</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/work/modal/confirmation-toolbox.component.html
// module id = ./src/app/modules/work/modal/confirmation-toolbox.component.html
// module chunks = main